//#region IMPORT
import React, { useEffect } from 'react';
import { BusinessGridCommon } from '../../../../Components/BusinessGridCommon';
import { Dialog } from '../../../../Components/MUIs';
import { useSelector } from 'react-redux';
import 'ag-grid-enterprise';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { DatePicker } from '../../../../Components/MUIs';
import {
  getColumnDefs1,
  IsMeetingMinutesLocked,
} from './SUB_BASIC_03_ColumnDefs';
import {
  Box,
  Button,
  IconButton,
  Paper,
  TextField,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Chip,
  MenuItem,
  FormControl,
  Select,
} from '@mui/material';
import {
  Close as CloseIcon,
  PersonAdd as PersonAddIcon,
  ExpandMore as ExpandMoreIcon,
  Add as AddIcon,
  Delete as DeleteIcon,
  AccountCircle as AccountCircleIcon,
  EventNote as EventNoteIcon,
  Assignment as AssignmentIcon,
  AttachFile as AttachFileIcon,
  Download as DownloadIcon,
} from '@mui/icons-material';
import dayjs from 'dayjs';
import { AgGridReact } from 'ag-grid-react';
import { FileForm } from '../../../../Components/FileForm';
//#endregion

/**
1. 회의등록
2. 참석자 참석여부 알림 요청하기 
3. 회의 개최클릭 -> 회의 개최중으로 상태변경
4. 회의결과등록
5. 회의 완료로 상태변경
6. 참석자한테 회의결과에 대한 서명요청 (실제 참석여부를 확인하는 용도)
7. 대표자에게 결재요청
8. 회의 만료로 상태변경
**/

// 전화번호 포맷팅 함수
const formatPhoneNumber = (value) => {
  // 숫자만 추출
  const phoneNumber = value.replace(/[^\d]/g, '');

  // 길이에 따라 포맷팅
  if (phoneNumber.length <= 3) {
    return phoneNumber;
  } else if (phoneNumber.length <= 7) {
    return `${phoneNumber.slice(0, 3)}-${phoneNumber.slice(3)}`;
  } else if (phoneNumber.length <= 11) {
    return `${phoneNumber.slice(0, 3)}-${phoneNumber.slice(3, 7)}-${phoneNumber.slice(7)}`;
  } else {
    // 11자리 초과시 11자리까지만 사용
    return `${phoneNumber.slice(0, 3)}-${phoneNumber.slice(3, 7)}-${phoneNumber.slice(7, 11)}`;
  }
};

function SUB_BASIC_03(props) {
  const searchInfo = useSelector((state) => state.SearchInfo);
  const meetingReadOnly = IsMeetingMinutesLocked(props.modalRowData2);
  // 협의체회의록 그리드 컬럼
  const columnDefs1 = getColumnDefs1(props);

  //#region AuthButton 이벤트
  useEffect(() => {
    if (props.filterClick3) {
      if (!props.validateSelection()) {
        props.setFilterClick3(false);
        return;
      }

      props.gridRef1.current.api.setQuickFilter(searchInfo?.searchText || '');
      props.setFilterClick3(false);
    }
    if (props.searchClick3) {
      props.ResetLogic1();
      if (!props.validateSelection()) {
        props.setSearchClick3(false);
        return;
      }

      props.SearchLogic1(searchInfo?.custCd || '');
      props.setSearchClick3(false);
    }
    if (props.addClick3) {
      if (!props.validateSelection()) {
        props.setAddClick3(false);
        return;
      }
      props.setAddClick3(false);
    }

    if (props.saveClick3) {
      // 선택된 행이 없을 경우 알림창 표시
      if (!props.deletedRowData1 || props.deletedRowData1.length === 0) {
        props.dispatch(
          props.showSnackbar({
            message: '삭제할 행을 선택하세요.',
            type: 'warning',
          })
        );
        props.setSaveClick3(false);
        return;
      }

      // 유효성 검사 실패 시 종료
      if (!props.validateSelection()) {
        props.setSaveClick3(false);
        return;
      }

      // 삭제 실행 전 삭제 예정 행 수 확인
      const deletedCount = props.deletedRowData1?.length || 0;

      // deleteHandler1.DeleteLogic 호출
      props.deleteHandler1
        .DeleteLogic()
        .then(() => {
          // 삭제 성공 시 알림
          if (deletedCount > 0) {
            // 정상 완료 시 로그
            props.SaveActionLog(props.deletedRowData1, {
              menuId: props.SCREEN_MENU_ID,
              coCd:
                props.userInfo.authCd === 'ADMIN' ? '' : props.userInfo.coCd,
              userId: props.userInfo.userid,
              logResult: 'SUCCESS',
            });

            props.dispatch(
              props.showSnackbar({
                message: `삭제되었습니다.`,
                type: 'success',
              })
            );
            // 🔥 그리드 새로고침 추가
            props.SearchLogic1(searchInfo?.custCd || '');
          }
        })
        .catch((error) => {
          // 오류 시 로그
          props.SaveActionLog(props.deletedRowData1, {
            menuId: props.SCREEN_MENU_ID,
            coCd: props.userInfo.authCd === 'ADMIN' ? '' : props.userInfo.coCd,
            userId: props.userInfo.userid,
            logResult: 'ERROR',
            errorMsg: error.message,
          });
          // 삭제 실패 시 에러는 이미 useDelete에서 처리됨
          console.error('삭제 실패:', error);
        });

      props.setSaveClick3(false);
    }
    if (props.deleteClick3) {
      if (!props.validateSelection()) {
        props.setDeleteClick3(false);
        return;
      }

      props.DeleteLogic1();
      props.setDeleteClick3(false);
    }
    if (props.printClick3) {
      if (!props.validateSelection()) {
        props.setPrintClick3(false);
        return;
      }

      props.PrintLogic3(); // 2025-10-02 양식 변경
      props.setPrintClick3(false); // 인쇄 후 상태 리셋
    }
    if (props.listClick3) {
      if (!props.validateSelection()) {
        props.setListClick3(false);
        return;
      }

      if (!props.selectedRowData1 || props.selectedRowData1.length === 0) {
        props.dispatch(
          props.showSnackbar({
            message: '결재요청할 회의를 선택해주세요.',
            type: 'warning',
          })
        );
        props.setListClick3(false);
        return;
      }

      props.SignRequest('1', props.selectedRowData1[0]);
      props.setListClick3(false);
    }
  }, [
    props.filterClick3,
    props.searchClick3,
    props.addClick3,
    props.saveClick3,
    props.deleteClick3,
    props.printClick3,
    props.listClick3,
  ]);

  //#endregion

  return (
    <React.Fragment>
      <BusinessGridCommon
        getRowId={(params) => {
          return params.data.no;
        }}
        gridRef={props.gridRef1}
        editable={true}
        columnDefs={columnDefs1}
        rowData={props.rowData1}
        setSelectedRowData={props.setSelectedRowData1}
        setChangedRowData={props.setChangedRowData1}
        rowSelection={'multiple'}
        deleteClick1={() => {
          if (!props.validateSelection()) return;
          props.DeleteLogic1?.();
        }}
        refreshClick1={() => {
          if (!props.validateSelection()) return;

          props.SearchLogic1(searchInfo?.custCd || '');
        }}
        addClick1={(e) => {
          if (!props.validateSelection()) return;
          props.currentChaebunRef.current = '';
          props.setModalRowData2({
            chaebun: '',
            proceedingsTitle: '',
            proceedingsDate: dayjs(),
            proceedingsStartTime: null,
            proceedingsEndTime: null,
            proceedingsLocation: '',
            meetingHost: '',
            meetingCycle: '',
            totalWorkers: 0,
          });
          props.setAttendeeData([]);
          props.setSubcontractorAttendees({});
          props.setSubcontractorList([]);
          props.ResetImage();
          props.setMeetingAgendaData([]);
          props.setModalToggle2(true);
        }}
        onRowClicked={(e) => {
          // 필요 시 특정 행 선택 등 처리
          const gridApi = props.gridRef1.current.api;
          const clickedRowIndex = e.rowIndex;

          const isCheckboxClick = e.event?.target?.type === 'checkbox';

          if (!isCheckboxClick) {
            gridApi.ensureIndexVisible(clickedRowIndex, 'middle');
            gridApi.setFocusedCell(clickedRowIndex, 'coNm');

            const copied = JSON.parse(JSON.stringify(e.data));
            props.handleRowSelection(copied, clickedRowIndex);

            gridApi
              .getDisplayedRowAtIndex(clickedRowIndex)
              ?.setSelected(true, false);
          }
        }}
        onSelectionChanged={() => {
          const gridApi = props.gridRef1?.current?.api;
          const selectedNodes = gridApi.getSelectedNodes();
          const selectedData = selectedNodes.map((n) => n.data);
          props.selectedRowNosRef.current = new Set(
            selectedData.map((r) => r.no)
          );
          props.setSelectedRowData1(selectedData);
        }}
      />

      {/* 회의록 팝업 창 */}
      {props.modalToggle2 && (
        <Dialog
          title={null}
          titleSx={{ display: 'none', p: 0, m: 0, height: 0, minHeight: 0 }}
          open={props.modalToggle2}
          onClose={() => props.setModalToggle2(false)}
          contentSx={{
            p: '0 !important',
            pt: '0 !important',
            pb: '0 !important',
            px: '0 !important',
            py: '0 !important',
            m: '0 !important',
            mt: '0 !important',
            overflow: 'hidden',
            height: '85vh',
            maxHeight: '85vh',
            display: 'flex',
            flexDirection: 'column',
            '&.MuiDialogContent-root': {
              padding: '0 !important',
              paddingTop: '0 !important',
              height: '85vh',
              maxHeight: '85vh',
              display: 'flex',
              flexDirection: 'column',
            },
          }}
          sx={{
            '& .MuiDialog-paper': {
              height: '90vh',
              maxHeight: '90vh',
              overflow: 'hidden',
            },
          }}
          fullWidth
          maxWidth="md"
          saveButtonName={meetingReadOnly ? '' : '저장'}
          closeButtonName="닫기"
          useSaveButton={!meetingReadOnly}
          useSaveAfterClose={false}
          useCloseButton={false}
          onSave={() => {
            if (meetingReadOnly) {
              props.dispatch(
                props.showSnackbar({
                  message: '서명 요청 후에는 회의록을 수정할 수 없습니다.',
                  type: 'warning',
                })
              );
              return;
            }
            props.SaveLogic1();
          }}
          content={
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                height: '100%',
                maxHeight: '90vh',
                bgcolor: '#f6f7f8',
                p: 0,
                m: 0,
                mt: 0,
                pt: 0,
                overflow: 'hidden',
              }}
            >
              {/* Top Navigation Bar */}
              <Paper
                elevation={0}
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  borderBottom: '1px solid #f0f2f4',
                  bgcolor: 'white',
                  px: 3,
                  py: 1.5,
                  flexShrink: 0,
                  zIndex: 20,
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 2,
                    color: '#111418',
                  }}
                >
                  <Box
                    sx={{
                      width: 32,
                      height: 32,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      bgcolor: 'rgba(19, 127, 236, 0.1)',
                      color: 'primary.main',
                      borderRadius: 1.5,
                    }}
                  >
                    <EventNoteIcon sx={{ fontSize: 24 }} />
                  </Box>
                  <Typography
                    variant="h6"
                    sx={{
                      color: '#111418',
                      fontSize: 18,
                      fontWeight: 'bold',
                      letterSpacing: -0.15,
                    }}
                  >
                    {meetingReadOnly ? '회의조회' : '회의작성'}
                  </Typography>
                </Box>
                <IconButton
                  onClick={() => props.setModalToggle2(false)}
                  sx={{
                    color: '#5f6368',
                    '&:hover': {
                      bgcolor: 'rgba(0, 0, 0, 0.04)',
                    },
                  }}
                >
                  <CloseIcon />
                </IconButton>
              </Paper>

              {/* Main Content - Scrollable */}
              <Box
                sx={{
                  flex: 1,
                  p: 2,
                  overflowY: 'auto',
                  overflowX: 'hidden',
                  minHeight: 0,
                }}
              >
                {meetingReadOnly && (
                  <Box
                    sx={{
                      mb: 2,
                      p: 2,
                      backgroundColor: '#e8f4fd',
                      border: '1px solid #90caf9',
                      borderRadius: 2,
                    }}
                  >
                    <Typography
                      variant="body1"
                      sx={{ fontWeight: 600, color: '#1565c0', mb: 0.5 }}
                    >
                      회의록 수정 불가
                    </Typography>
                    <Typography variant="body2" sx={{ color: '#1976d2' }}>
                      서명 요청이 진행된 회의록은 수정할 수 없습니다. 조회만
                      가능합니다.
                    </Typography>
                  </Box>
                )}
                {/* 회의 기본 정보 */}
                <Paper
                  elevation={0}
                  sx={{
                    p: 2,
                    mb: 2,
                    bgcolor: 'white',
                    border: '1px solid #e0e0e0',
                    borderRadius: 2,
                  }}
                >
                  <Box sx={{ mb: 2 }}>
                    <Typography
                      variant="body1"
                      sx={{
                        fontWeight: 600,
                        color: '#111418',
                        mb: 1,
                      }}
                    >
                      회의제목 <span style={{ color: 'red' }}>*</span>
                    </Typography>
                    <TextField
                      value={props.modalRowData2?.proceedingsTitle || ''}
                      onChange={(e) => {
                        const value = e.target.value.slice(0, 100); // 최대 100자 제한
                        props.setModalRowData2({
                          ...props.modalRowData2,
                          proceedingsTitle: value,
                        });
                      }}
                      fullWidth
                      required
                      disabled={meetingReadOnly}
                      error={!props.modalRowData2?.proceedingsTitle?.trim()}
                      inputProps={{
                        maxLength: 100,
                      }}
                      helperText={
                        !props.modalRowData2?.proceedingsTitle?.trim()
                          ? '회의제목을 입력해주세요.'
                          : `${(props.modalRowData2?.proceedingsTitle || '').length}/100`
                      }
                    />
                  </Box>
                  <Box sx={{ mb: 2 }}>
                    <Typography
                      variant="body1"
                      sx={{
                        mb: 1,
                        fontWeight: 600,
                        color: '#111418',
                      }}
                    >
                      회의날짜
                    </Typography>
                    <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
                      <Box sx={{ flex: 1 }}>
                        <Typography
                          variant="body2"
                          sx={{ mb: 1, fontSize: '0.875rem' }}
                        >
                          회의날짜 <span style={{ color: 'red' }}>*</span>
                        </Typography>
                        <DatePicker
                          placeholder="회의날짜"
                          disabled={meetingReadOnly}
                          value={
                            props.modalRowData2?.proceedingsDate
                              ? dayjs(
                                  props.modalRowData2.proceedingsDate,
                                  'YYYY-MM-DD'
                                )
                              : dayjs()
                          }
                          onChange={(date) => {
                            if (meetingReadOnly) return;
                            const newData = {
                              ...props.modalRowData2,
                              proceedingsDate: date
                                ? date.format('YYYY-MM-DD')
                                : dayjs().format('YYYY-MM-DD'),
                            };
                            props.setModalRowData2(newData);
                          }}
                          format="YYYY-MM-DD"
                          views={['year', 'month', 'day']}
                          InputLabelProps={{
                            shrink: true,
                          }}
                        />
                      </Box>

                      <Box sx={{ flex: 1 }}>
                        <Typography
                          variant="body2"
                          sx={{ mb: 1, fontSize: '0.875rem' }}
                        >
                          시작시간 (HH:mm){' '}
                          <span style={{ color: 'red' }}>*</span>
                        </Typography>
                        <DatePicker
                          placeholder="시작시간"
                          disabled={meetingReadOnly}
                          value={
                            props.modalRowData2?.proceedingsStartTime || null
                          }
                          onChange={(date) => {
                            if (meetingReadOnly) return;
                            props.setModalRowData2({
                              ...props.modalRowData2,
                              proceedingsStartTime: date,
                            });
                          }}
                          format="HH:mm"
                          views={['hours', 'minutes']}
                          InputLabelProps={{
                            shrink: true,
                          }}
                        />
                      </Box>

                      <Box sx={{ flex: 1 }}>
                        <Typography
                          variant="body2"
                          sx={{ mb: 1, fontSize: '0.875rem' }}
                        >
                          종료시간 (HH:mm)
                        </Typography>
                        <DatePicker
                          placeholder="종료시간"
                          disabled={meetingReadOnly}
                          value={
                            props.modalRowData2?.proceedingsEndTime || null
                          }
                          onChange={(date) => {
                            if (meetingReadOnly) return;
                            props.setModalRowData2({
                              ...props.modalRowData2,
                              proceedingsEndTime: date,
                            });
                          }}
                          format="HH:mm"
                          views={['hours', 'minutes']}
                          InputLabelProps={{
                            shrink: true,
                          }}
                        />
                      </Box>
                    </Box>
                  </Box>
                  <Box>
                    <Typography
                      variant="body1"
                      sx={{
                        mb: 1,
                        fontWeight: 600,
                        color: '#111418',
                      }}
                    >
                      회의장소 <span style={{ color: 'red' }}>*</span>
                    </Typography>
                    <TextField
                      value={props.modalRowData2?.proceedingsLocation || ''}
                      onChange={(e) => {
                        const value = e.target.value.slice(0, 100); // 최대 100자 제한
                        props.setModalRowData2({
                          ...props.modalRowData2,
                          proceedingsLocation: value,
                        });
                      }}
                      fullWidth
                      required
                      disabled={meetingReadOnly}
                      error={!props.modalRowData2?.proceedingsLocation?.trim()}
                      inputProps={{
                        maxLength: 100,
                      }}
                      helperText={
                        !props.modalRowData2?.proceedingsLocation?.trim()
                          ? '회의장소를 입력해주세요.'
                          : `${(props.modalRowData2?.proceedingsLocation || '').length}/100`
                      }
                    />
                  </Box>
                  <Box>
                    <Typography
                      variant="body1"
                      sx={{
                        mb: 1,
                        fontWeight: 600,
                        color: '#111418',
                      }}
                    >
                      회의주관 / 회의주기
                    </Typography>
                    <Box
                      sx={{ display: 'flex', gap: 2, alignItems: 'flex-start' }}
                    >
                      <Box sx={{ flex: 1 }}>
                        <TextField
                          value={props.modalRowData2?.meetingHost || ''}
                          onChange={(e) => {
                            const value = e.target.value.slice(0, 100); // 최대 100자 제한
                            props.setModalRowData2({
                              ...props.modalRowData2,
                              meetingHost: value,
                            });
                          }}
                          fullWidth
                          disabled={meetingReadOnly}
                          inputProps={{
                            maxLength: 100,
                          }}
                          helperText={`${(props.modalRowData2?.meetingHost || '').length}/100`}
                        />
                      </Box>
                      <Box sx={{ flex: 1 }}>
                        <FormControl fullWidth disabled={meetingReadOnly}>
                          <Select
                            value={props.modalRowData2?.meetingCycle || ''}
                            onChange={(e) => {
                              props.setModalRowData2({
                                ...props.modalRowData2,
                                meetingCycle: e.target.value,
                              });
                            }}
                            displayEmpty
                          >
                            <MenuItem value="">선택하세요</MenuItem>
                            <MenuItem value="정기">정기</MenuItem>
                            <MenuItem value="수시">수시</MenuItem>
                          </Select>
                        </FormControl>
                      </Box>
                    </Box>
                  </Box>
                </Paper>

                {/* 회의 참석자 정보 */}
                <Paper
                  elevation={0}
                  sx={{
                    p: 2,
                    mb: 2,
                    bgcolor: 'white',
                    border: '1px solid #e0e0e0',
                    borderRadius: 2,
                  }}
                >
                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      mb: 1,
                    }}
                  >
                    <Box>
                      <Typography variant="h6">
                        사업장 총 근로자수({props.modalRowData3.length}명)
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        우리 사업장 근로자 중 회의참석자를 선택하세요.
                      </Typography>
                    </Box>
                    {!meetingReadOnly && (
                    <Button
                      variant="contained"
                      startIcon={<AddIcon />}
                      onClick={() => {
                        // 참석인원 조회 함수 호출
                        props.handleAttendeeSearch();
                        props.setModalToggle3(true);
                      }}
                      sx={{
                        minWidth: '150px',
                        bgcolor: '#1976d2',
                        '&:hover': {
                          bgcolor: '#1565c0',
                        },
                      }}
                    >
                      참석인원추가하기
                    </Button>
                    )}
                  </Box>

                  {/* 회의작성 팝업의 참석자 그리드 */}
                  <div
                    className="ag-theme-alpine"
                    style={{ height: '500px', width: '100%' }}
                  >
                    <BusinessGridCommon
                      gridRef={props.gridRef2}
                      addYn1={'N'}
                      deleteYn1={'N'}
                      refreshYn1={'N'}
                      title1={
                        <span>
                          참석자 정보 <span style={{ color: 'red' }}>*</span>
                        </span>
                      }
                      columnDefs={[
                        {
                          field: 'name',
                          headerName: '성명',
                          width: 150,
                        },
                        {
                          field: 'position',
                          headerName: '직책',
                          width: 150,
                        },
                        {
                          field: 'rank',
                          headerName: '직위',
                          width: 150,
                        },
                        {
                          field: 'depNm',
                          headerName: '소속',
                          width: 200,
                          flex: 1,
                        },
                        {
                          field: 'tel',
                          headerName: '전화번호',
                          width: 150,
                        },
                        ...(meetingReadOnly
                          ? []
                          : [
                              {
                                field: 'actions',
                                headerName: '삭제',
                                width: 40,
                                cellRenderer: (params) => (
                                  <IconButton
                                    size="small"
                                    color="error"
                                    onClick={() => {
                                      const updatedData =
                                        props.attendeeData.filter(
                                          (_, index) =>
                                            index !== params.rowIndex
                                        );
                                      props.setAttendeeData(updatedData);
                                    }}
                                    sx={{
                                      padding: '4px',
                                      '&:hover': {
                                        bgcolor: '#ffebee',
                                      },
                                    }}
                                  >
                                    <DeleteIcon />
                                  </IconButton>
                                ),
                                sortable: false,
                                filter: false,
                                resizable: false,
                              },
                            ]),
                      ]}
                      rowData={props.attendeeData}
                      defaultColDef={{
                        minWidth: 80,
                        resizable: true,
                        sortable: true,
                      }}
                      suppressToolPanel={true}
                      suppressMenuHide={true}
                      suppressColumnMoveAnimation={true}
                    />
                  </div>
                </Paper>

                {/* 수급업체 목록 영역 */}
                <Paper
                  elevation={0}
                  sx={{
                    mb: 3,
                    p: 3,
                    bgcolor: 'white',
                    border: '1px solid #e0e0e0',
                    borderRadius: 2,
                  }}
                >
                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      mb: 3,
                    }}
                  >
                    <Typography
                      variant="h6"
                      sx={{
                        fontWeight: 600,
                        color: '#111418',
                      }}
                    >
                      수급업체 참석자 관리
                    </Typography>
                    {!meetingReadOnly && (
                    <Button
                      variant="contained"
                      startIcon={<AddIcon />}
                      onClick={() => {
                        props.setModalToggle7(true);
                        props.handleSubcontractorSearch();
                      }}
                      sx={{
                        bgcolor: '#1976d2',
                        '&:hover': {
                          bgcolor: '#1565c0',
                        },
                      }}
                    >
                      수급업체 추가하기
                    </Button>
                    )}
                  </Box>

                  {props.subcontractorList?.map((subcontractor, index) => (
                    <Accordion
                      key={subcontractor.custCd || subcontractor.custNm}
                      defaultExpanded={subcontractor.isExpanded !== false} // 기본적으로 펼쳐진 상태
                      sx={{
                        mb: 2,
                        borderRadius: 2,
                        boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                        '&:before': {
                          display: 'none',
                        },
                        '&.Mui-expanded': {
                          margin: '0 0 16px 0',
                        },
                      }}
                    >
                      <AccordionSummary
                        expandIcon={
                          <ExpandMoreIcon sx={{ color: '#1976d2' }} />
                        }
                        aria-controls={`panel-${subcontractor.custCd}-content`}
                        id={`panel-${subcontractor.custCd}-header`}
                        sx={{
                          bgcolor: '#ffffff',
                          borderRadius: '8px 8px 0 0',
                          minHeight: 56,
                          '&.Mui-expanded': {
                            minHeight: 56,
                          },
                          '& .MuiAccordionSummary-content': {
                            margin: '12px 0',
                            '&.Mui-expanded': {
                              margin: '12px 0',
                            },
                          },
                        }}
                      >
                        <Box
                          sx={{
                            display: 'flex',
                            alignItems: 'center',
                            width: '100%',
                          }}
                        >
                          <Box
                            sx={{
                              width: 32,
                              height: 32,
                              borderRadius: '50%',
                              bgcolor: '#1976d2',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              mr: 2,
                              color: 'white',
                              fontWeight: 'bold',
                              fontSize: '14px',
                            }}
                          >
                            {index + 1}
                          </Box>
                          <Box sx={{ flex: 1 }}>
                            <Typography
                              variant="h6"
                              sx={{
                                fontWeight: 'bold',
                                color: '#333',
                                mb: 0.5,
                              }}
                            >
                              {subcontractor.custNm || subcontractor.custCd}
                            </Typography>
                            <Typography variant="body2" color="text.secondary">
                              대표자연락처:{' '}
                              {subcontractor.ceoTel
                                ? formatPhoneNumber(subcontractor.ceoTel)
                                : '미등록'}{' '}
                              | 대표자성명: {subcontractor.ceo || '미등록'} |
                              참석자:{' '}
                              {props.subcontractorAttendees[
                                subcontractor.custCd
                              ]?.length || 0}
                              명
                            </Typography>
                          </Box>
                          <IconButton
                            size="small"
                            disabled={meetingReadOnly}
                            onClick={(e) => {
                              e.stopPropagation(); // 아코디언 확장/축소 방지
                              if (meetingReadOnly) return;
                              props.removeSubcontractor(subcontractor.custCd);
                            }}
                            sx={{
                              color: 'error.main',
                              display: meetingReadOnly ? 'none' : 'inline-flex',
                              '&:hover': {
                                backgroundColor: 'rgba(244, 67, 54, 0.1)',
                              },
                            }}
                          >
                            <CloseIcon fontSize="small" />
                          </IconButton>
                        </Box>
                      </AccordionSummary>
                      <AccordionDetails
                        sx={{
                          bgcolor: '#ffffff',
                          borderRadius: '0 0 8px 8px',
                          p: 1,
                          borderTop: '1px solid #e0e0e0',
                        }}
                      >
                        <Box sx={{ mb: 0 }}>
                          {/* 각 수급업체별 참석자 목록 표시 */}
                          {props.subcontractorAttendees[
                            subcontractor.custCd
                          ]?.map((attendee, attendeeIndex) => (
                            <Box
                              key={attendeeIndex}
                              sx={{
                                display: 'flex',
                                alignItems: 'center',
                                p: 1,
                                mb: 1.5,
                                bgcolor: '#ffffff',
                                borderRadius: 2,
                                border: '1px solid #e0e0e0',
                                boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
                                transition: 'all 0.2s ease-in-out',
                                '&:hover': {
                                  boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
                                  borderColor: '#1976d2',
                                },
                              }}
                            >
                              {/* 번호 표시 */}
                              <Box
                                sx={{
                                  width: 32,
                                  height: 32,
                                  borderRadius: '50%',
                                  flexShrink: 0,
                                  bgcolor: '#e3f2fd',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  mr: 1,
                                  color: '#1976d2',
                                  fontWeight: 'bold',
                                  fontSize: '14px',
                                  border: '2px solid #bbdefb',
                                }}
                              >
                                {attendeeIndex + 1}
                              </Box>

                              {/* 입력 필드들 */}
                              <Box
                                sx={{
                                  flex: 1,
                                  display: 'flex',
                                  alignItems: 'center',
                                  gap: 1,
                                }}
                              >
                                <TextField
                                  label="이름"
                                  value={attendee.name}
                                  disabled={meetingReadOnly}
                                  onChange={(e) => {
                                    if (meetingReadOnly) return;
                                    const newName = e.target.value;

                                    // 중복 체크
                                    const allAttendees = Object.values(
                                      props.subcontractorAttendees
                                    ).flat();
                                    const isDuplicate = allAttendees.some(
                                      (otherAttendee) =>
                                        otherAttendee.id !== attendee.id &&
                                        otherAttendee.name
                                          .trim()
                                          .toLowerCase() ===
                                          newName.trim().toLowerCase() &&
                                        otherAttendee.phone.trim() ===
                                          attendee.phone.trim() &&
                                        newName.trim() &&
                                        attendee.phone.trim()
                                    );

                                    if (isDuplicate) {
                                      props.dispatch(
                                        props.showSnackbar({
                                          message: `동일한 이름과 연락처의 참석자가 이미 존재합니다.`,
                                          type: 'warning',
                                        })
                                      );
                                      return;
                                    }

                                    props.updateSubcontractorAttendee(
                                      subcontractor.custCd,
                                      attendee.id,
                                      'name',
                                      newName
                                    );
                                  }}
                                  size="small"
                                  sx={{
                                    width: '160px',
                                    '& .MuiOutlinedInput-root': {
                                      borderRadius: 2,
                                      '&:hover fieldset': {
                                        borderColor: '#1976d2',
                                      },
                                      '&.Mui-focused fieldset': {
                                        borderColor: '#1976d2',
                                      },
                                    },
                                  }}
                                  placeholder="참석자 이름"
                                />
                                <TextField
                                  label="연락처"
                                  value={formatPhoneNumber(
                                    attendee.phone || ''
                                  )}
                                  disabled={meetingReadOnly}
                                  onChange={(e) => {
                                    if (meetingReadOnly) return;
                                    const inputValue = e.target.value;
                                    const formattedPhone =
                                      formatPhoneNumber(inputValue);

                                    // 중복 체크 (포맷된 번호로 체크)
                                    const allAttendees = Object.values(
                                      props.subcontractorAttendees
                                    ).flat();
                                    const isDuplicate = allAttendees.some(
                                      (otherAttendee) =>
                                        otherAttendee.id !== attendee.id &&
                                        otherAttendee.name
                                          .trim()
                                          .toLowerCase() ===
                                          attendee.name.trim().toLowerCase() &&
                                        otherAttendee.phone.trim() ===
                                          formattedPhone.trim() &&
                                        attendee.name.trim() &&
                                        formattedPhone.trim()
                                    );

                                    if (isDuplicate) {
                                      props.dispatch(
                                        props.showSnackbar({
                                          message: `동일한 이름과 연락처의 참석자가 이미 존재합니다.`,
                                          type: 'warning',
                                        })
                                      );
                                      return;
                                    }

                                    props.updateSubcontractorAttendee(
                                      subcontractor.custCd,
                                      attendee.id,
                                      'phone',
                                      formattedPhone
                                    );
                                  }}
                                  size="small"
                                  sx={{
                                    width: '180px',
                                    '& .MuiOutlinedInput-root': {
                                      borderRadius: 2,
                                      '&:hover fieldset': {
                                        borderColor: '#1976d2',
                                      },
                                      '&.Mui-focused fieldset': {
                                        borderColor: '#1976d2',
                                      },
                                    },
                                  }}
                                  placeholder="010-0000-0000"
                                  inputProps={{
                                    maxLength: 13, // 010-0000-0000 형식으로 최대 13자
                                  }}
                                />
                                <TextField
                                  label="직위"
                                  value={attendee.partnerRank || ''}
                                  size="small"
                                  disabled={meetingReadOnly}
                                  onChange={(e) => {
                                    if (meetingReadOnly) return;
                                    props.updateSubcontractorAttendee(
                                      subcontractor.custCd,
                                      attendee.id,
                                      'partnerRank',
                                      e.target.value
                                    );
                                  }}
                                  placeholder="직위 입력"
                                  sx={{
                                    width: '160px',
                                    '& .MuiOutlinedInput-root': {
                                      borderRadius: 2,
                                      '&:hover fieldset': {
                                        borderColor: '#1976d2',
                                      },
                                      '&.Mui-focused fieldset': {
                                        borderColor: '#1976d2',
                                      },
                                    },
                                  }}
                                />
                              </Box>

                              {/* 삭제 버튼 */}
                              {!meetingReadOnly && (
                              <IconButton
                                size="small"
                                onClick={() => {
                                  props.removeSubcontractorAttendee(
                                    subcontractor.custCd,
                                    attendee.id
                                  );
                                }}
                                sx={{
                                  color: 'error.main',
                                  ml: 1,
                                  '&:hover': {
                                    backgroundColor: 'rgba(244, 67, 54, 0.1)',
                                    transform: 'scale(1.1)',
                                  },
                                  transition: 'all 0.2s ease-in-out',
                                }}
                              >
                                <CloseIcon fontSize="small" />
                              </IconButton>
                              )}
                            </Box>
                          ))}

                          {/* 참석자 추가 버튼 */}
                          {!meetingReadOnly && (
                          <Button
                            variant="outlined"
                            startIcon={<PersonAddIcon />}
                            onClick={() => {
                              props.addSubcontractorAttendee(
                                subcontractor.custCd
                              );
                            }}
                            sx={{
                              mt: 2,
                              borderRadius: 2,
                              borderColor: '#1976d2',
                              color: '#1976d2',
                              '&:hover': {
                                borderColor: '#1565c0',
                                backgroundColor: 'rgba(25, 118, 210, 0.04)',
                                transform: 'translateY(-1px)',
                              },
                              transition: 'all 0.2s ease-in-out',
                              fontWeight: 'bold',
                            }}
                          >
                            참석자 추가
                          </Button>
                          )}
                        </Box>
                      </AccordionDetails>
                    </Accordion>
                  ))}

                  {(!props.subcontractorList ||
                    props.subcontractorList.length === 0) && (
                    <Box
                      sx={{
                        textAlign: 'center',
                        py: 6,
                        bgcolor: '#ffffff',
                        borderRadius: 2,
                        border: '2px dashed #e0e0e0',
                      }}
                    >
                      <Typography
                        variant="h6"
                        color="text.secondary"
                        sx={{ mb: 2 }}
                      >
                        수급업체 목록이 없습니다
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        수급업체 추가하기 버튼을 클릭하여 수급업체를 추가하세요
                      </Typography>
                    </Box>
                  )}
                </Paper>

                {/* 진행사진 업로드 */}
                <Paper
                  elevation={0}
                  sx={{
                    mb: 3,
                    p: 3,
                    border: '1px solid #e0e0e0',
                    borderRadius: 2,
                    backgroundColor: 'white',
                  }}
                >
                  <Typography
                    variant="h6"
                    sx={{
                      mb: 2,
                      fontWeight: 600,
                      color: '#111418',
                      fontSize: 16,
                    }}
                  >
                    진행사진 업로드
                  </Typography>

                  {/* FileForm 영역 */}
                  <Box sx={{ display: 'flex', gap: '1rem', mb: 2 }}>
                    {!meetingReadOnly && (
                    <FileForm
                      datas={[
                        {
                          type: 'file',
                          name: '파일',
                          onChange: (event) => {
                            const fileList = event.target.files;
                            if (Object.keys(fileList).length === 0) return;

                            const file = fileList[0];

                            const validTypes = [
                              'image/jpeg',
                              'image/png',
                              'image/gif',
                              'image/bmp',
                              'image/svg+xml',
                            ];
                            if (!validTypes.includes(file.type)) {
                              props.dispatch(
                                props.showSnackbar({
                                  message: '이미지 파일만 업로드 가능합니다.',
                                  type: 'warning',
                                })
                              );
                              return false;
                            }

                            const reader = new FileReader();
                            reader.readAsDataURL(file);
                            reader.onload = (e) => {
                              fetch(e.target.result)
                                .then((res) => res.blob())
                                .then((blob) => {
                                  const saveName = `${new Date()
                                    .toISOString()
                                    .replace(/T/, '')
                                    .replace(/\..+/, '')
                                    .replace(/-/g, '')
                                    .replace(/:/g, '')}.png`;

                                  const image = new File([blob], saveName, {
                                    type: 'image/png',
                                  });

                                  props.setInputs((prev) => ({
                                    ...prev,
                                    mapFile: image,
                                    filePath: `Business/${
                                      searchInfo?.custCd || ''
                                    }/SUB_BASIC_02/${saveName}`,
                                    fileName: file.name,
                                    saveName: saveName,
                                    newYn: 'Y',
                                  }));

                                  props.inputsRef.current = {
                                    ...props.inputsRef.current,
                                    mapFile: image,
                                    filePath: `Business/${
                                      searchInfo?.custCd || ''
                                    }/SUB_BASIC_02/${saveName}`,
                                    fileName: file.name,
                                    saveName: saveName,
                                    newYn: 'Y',
                                  };

                                  props.imgRef2.current = reader.result;
                                });
                            };
                            reader.onerror = (error) => {
                              console.log(error);
                            };
                          },
                        },
                        {
                          name: '파일명',
                          value: props.inputsRef.current.fileName,
                          disabled: true,
                        },
                      ]}
                    />
                    )}
                    {meetingReadOnly && (
                      <TextField
                        label="파일명"
                        value={props.inputsRef.current.fileName || ''}
                        disabled
                        fullWidth
                      />
                    )}
                  </Box>

                  {/* 이미지 미리보기 + 삭제 버튼 */}
                  <Box
                    sx={{
                      border: '1px dashed #ccc',
                      borderRadius: 2,
                      padding: 2,
                      backgroundColor: '#fff',
                      minHeight: 150,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      position: 'relative',
                    }}
                  >
                    {props.imgRef2.current ? (
                      <>
                        <img
                          src={props.imgRef2.current}
                          alt="진행사진 이미지"
                          style={{
                            maxWidth: '100%',
                            maxHeight: '200px',
                            objectFit: 'contain',
                            borderRadius: 4,
                          }}
                        />
                        {!meetingReadOnly &&
                          !props.meetingAgendaData.some(
                            (item) => item.STATE === '만료'
                          ) &&
                          ((item) => item.isExpired) && (
                            <IconButton
                              onClick={props.ResetImage}
                              sx={{
                                position: 'absolute',
                                top: 8,
                                right: 8,
                                backgroundColor: 'rgba(255,255,255,0.8)',
                                '&:hover': {
                                  backgroundColor: 'rgba(255,255,255,1)',
                                },
                              }}
                              size="small"
                            >
                              <DeleteIcon color="error" />
                            </IconButton>
                          )}
                      </>
                    ) : (
                      <Typography color="text.secondary">
                        등록된 이미지가 없습니다.
                      </Typography>
                    )}
                  </Box>
                </Paper>

                {/* 회의 안건 그리드 */}
                <Paper
                  elevation={0}
                  sx={{
                    mb: 3,
                    p: 3,
                    border: '1px solid #e0e0e0',
                    borderRadius: 2,
                    backgroundColor: 'white',
                  }}
                >
                  <Typography
                    variant="h6"
                    sx={{
                      mb: 2,
                      fontWeight: 600,
                      color: '#111418',
                      fontSize: 16,
                    }}
                  >
                    회의 안건
                  </Typography>
                  {/* 회의안건 추가 버튼 */}
                  <Box sx={{ mb: 2 }}>
                    {!meetingReadOnly && (
                    <Button
                      variant="contained"
                      startIcon={<AddIcon />}
                      onClick={props.addMeetingAgenda}
                      sx={{
                        mb: 2,
                        borderRadius: 2,
                        fontWeight: 600,
                        textTransform: 'none',
                        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                        '&:hover': {
                          boxShadow: '0 4px 8px rgba(0,0,0,0.15)',
                        },
                      }}
                    >
                      회의안건 추가하기
                    </Button>
                    )}
                  </Box>
                  {/* 삭제 안내 문구 */}
                  {props.meetingAgendaData.some(
                    (item) => item.deleteYn === 'Y'
                  ) && (
                    <Box
                      sx={{
                        mb: 2,
                        p: 2,
                        backgroundColor: '#fff3e0',
                        border: '2px solid #ff9800',
                        borderRadius: 2,
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1,
                        boxShadow: '0 2px 8px rgba(255, 152, 0, 0.2)',
                      }}
                    >
                      <Box
                        sx={{
                          width: 24,
                          height: 24,
                          borderRadius: '50%',
                          backgroundColor: '#ff9800',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          color: 'white',
                          fontWeight: 'bold',
                          fontSize: '14px',
                        }}
                      >
                        !
                      </Box>
                      <Box>
                        <Typography
                          variant="body1"
                          sx={{
                            fontWeight: 'bold',
                            color: '#e65100',
                            mb: 0.5,
                          }}
                        >
                          삭제 예정 안건이 있습니다
                        </Typography>
                        <Typography
                          variant="body2"
                          sx={{
                            color: '#f57c00',
                          }}
                        >
                          저장 버튼을 클릭하면 빨간색으로 표시된 안건들이
                          영구적으로 삭제됩니다.
                        </Typography>
                      </Box>
                    </Box>
                  )}
                  <div
                    className="ag-theme-alpine"
                    style={{ height: '400px', width: '100%' }}
                  >
                    <AgGridReact
                      ref={props.gridRef5}
                      columnDefs={[
                        {
                          field: 'agendaName',
                          headerName: '협의사항',
                          width: 200,
                          editable: !meetingReadOnly,
                          flex: 1,
                          cellEditor: 'agTextCellEditor',
                          cellEditorParams: {
                            maxLength: 500,
                          },
                          cellStyle: (params) => {
                            // 필수항목이 비어있으면 빨간색 테두리 표시
                            if (
                              !params.value?.trim() &&
                              params.data.deleteYn !== 'Y'
                            ) {
                              return {
                                border: '2px solid #f44336',
                                backgroundColor: '#ffebee',
                              };
                            }
                            return null;
                          },
                        },
                        {
                          field: 'resultDiscussion',
                          headerName: '세부사항',
                          width: 300,
                          editable: !meetingReadOnly,
                          flex: 2,
                          cellEditor: 'agTextCellEditor',
                          cellEditorParams: {
                            maxLength: 1000,
                          },
                          cellStyle: (params) => {
                            // 필수항목이 비어있으면 빨간색 테두리 표시
                            if (
                              !params.value?.trim() &&
                              params.data.deleteYn !== 'Y'
                            ) {
                              return {
                                border: '2px solid #f44336',
                                backgroundColor: '#ffebee',
                              };
                            }
                            return null;
                          },
                        },
                        ...(meetingReadOnly
                          ? []
                          : [
                              {
                                field: 'actions',
                                headerName: '삭제',
                                width: 80,
                                cellRenderer: (e) => {
                                  if (
                                    props.meetingAgendaData.some(
                                      (item) => item.STATE === '만료'
                                    )
                                  ) {
                                    return null;
                                  }

                                  return (
                                    <IconButton
                                      color="error"
                                      onClick={() =>
                                        props.deleteMeetingAgenda(e.data.id)
                                      }
                                      size="small"
                                    >
                                      <DeleteIcon />
                                    </IconButton>
                                  );
                                },
                                cellStyle: {
                                  display: 'flex',
                                  justifyContent: 'center',
                                  alignItems: 'center',
                                },
                              },
                            ]),
                      ]}
                      rowData={props.meetingAgendaData}
                      getRowStyle={(params) => {
                        // 삭제 클릭 시 명확하게 표시
                        if (params.data.deleteYn === 'Y') {
                          return {
                            backgroundColor: '#ffcdd2',
                            opacity: 0.8,
                            textDecoration: 'line-through',
                            color: '#b71c1c',
                            fontWeight: 'bold',
                            border: '1px solid #d32f2f',
                            boxShadow: '0 2px 4px rgba(211, 47, 47, 0.3)',
                          };
                        }
                        return null;
                      }}
                      onCellValueChanged={(e) => {
                        const updatedData = props.meetingAgendaData.map(
                          (item) => {
                            if (item.id === e.data.id) {
                              return {
                                ...item,
                                [e.colDef.field]: e.newValue,
                                editYn: 'Y',
                              };
                            }
                            return item;
                          }
                        );

                        props.setMeetingAgendaData(updatedData);
                      }}
                      defaultColDef={{
                        resizable: true,
                        sortable: true,
                        filter: true,
                      }}
                      stopEditingWhenCellsLoseFocus={true}
                      suppressKeyboardEvent={(params) => {
                        // Tab 키로 다음 셀로 이동 허용
                        if (params.event.key === 'Tab') {
                          return false; // 기본 동작 허용
                        }
                        return false;
                      }}
                      onCellKeyDown={(params) => {
                        // Tab 키를 눌렀을 때 다음 셀로 이동
                        if (params.event.key === 'Tab') {
                          const currentRowIndex = params.rowIndex;
                          const currentColId = params.column.getColId();
                          const columnDefs = params.api.getColumnDefs();
                          const currentColIndex = columnDefs.findIndex(
                            (col) => col.field === currentColId
                          );

                          // 현재 행의 다음 컬럼으로 이동
                          if (currentColIndex < columnDefs.length - 1) {
                            // 같은 행의 다음 컬럼
                            const nextColKey =
                              columnDefs[currentColIndex + 1].field;
                            params.api.setFocusedCell(
                              currentRowIndex,
                              nextColKey
                            );
                            params.api.startEditingCell({
                              rowIndex: currentRowIndex,
                              colKey: nextColKey,
                            });
                            params.event.preventDefault();
                          } else {
                            // 마지막 컬럼이면 다음 행의 첫 번째 컬럼으로 이동
                            const nextRowIndex = currentRowIndex + 1;
                            if (
                              nextRowIndex < params.api.getDisplayedRowCount()
                            ) {
                              const firstColKey = columnDefs[0].field;
                              params.api.setFocusedCell(
                                nextRowIndex,
                                firstColKey
                              );
                              params.api.startEditingCell({
                                rowIndex: nextRowIndex,
                                colKey: firstColKey,
                              });
                              params.event.preventDefault();
                            }
                          }
                        }
                      }}
                    />
                  </div>
                </Paper>

                {/* 회의록 첨부파일 (회의록당 1개, 재등록 시 교체) */}
                <Paper
                  elevation={0}
                  sx={{
                    mb: 3,
                    p: 3,
                    border: '1px solid #e0e0e0',
                    borderRadius: 2,
                    backgroundColor: 'white',
                  }}
                >
                  <Typography
                    variant="h6"
                    sx={{
                      mb: 1,
                      fontWeight: 600,
                      color: '#111418',
                      fontSize: 16,
                    }}
                  >
                    회의록 첨부파일
                  </Typography>
                  <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{ mb: 2 }}
                  >
                    PDF, 엑셀, 워드, 한글, 파워포인트, 이미지 파일 1개를 첨부할
                    수 있으며, 다시 선택하면 기존 파일이 교체됩니다. 파일은
                    회의록 저장 시 함께 저장됩니다.
                  </Typography>
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: 1,
                      flexWrap: 'wrap',
                    }}
                  >
                    {!meetingReadOnly && (
                      <Button
                        variant="outlined"
                        component="label"
                        startIcon={<AttachFileIcon />}
                        sx={{ textTransform: 'none', fontWeight: 600 }}
                      >
                        파일 선택
                        <input
                          type="file"
                          hidden
                          accept=".pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.hwp,.hwpx,.png,.jpg,.jpeg"
                          onChange={(e) => {
                            props.ChangeMinutesFileLogic?.(e.target.files?.[0]);
                            e.target.value = '';
                          }}
                        />
                      </Button>
                    )}
                    {props.modalRowData2?.minutesFileName ? (
                      <Chip
                        icon={<DownloadIcon />}
                        label={props.modalRowData2.minutesFileName}
                        variant="outlined"
                        color="primary"
                        onClick={() =>
                          props.DownloadMinutesFileLogic?.(props.modalRowData2)
                        }
                        onDelete={
                          meetingReadOnly
                            ? undefined
                            : () => props.RemoveMinutesFileLogic?.()
                        }
                        sx={{ maxWidth: '100%' }}
                      />
                    ) : (
                      <Typography color="text.secondary" variant="body2">
                        첨부된 파일이 없습니다.
                      </Typography>
                    )}
                    {props.modalRowData2?.minutesFile && (
                      <Typography variant="caption" color="warning.main">
                        저장 전 (회의록 저장 시 업로드됩니다)
                      </Typography>
                    )}
                  </Box>
                </Paper>
              </Box>
            </Box>
          }
        />
      )}

      {/* 참석인원 추가 팝업 창 */}
      {props.modalToggle3 && (
        <Dialog
          title={null}
          titleSx={{ display: 'none', p: 0, m: 0, height: 0, minHeight: 0 }}
          open={props.modalToggle3}
          onClose={() => props.setModalToggle3(false)}
          contentSx={{
            p: '0 !important',
            pt: '0 !important',
            pb: '0 !important',
            px: '0 !important',
            py: '0 !important',
            m: '0 !important',
            mt: '0 !important',
            overflow: 'hidden',
            '&.MuiDialogContent-root': {
              padding: '0 !important',
              paddingTop: '0 !important',
            },
          }}
          fullWidth
          maxWidth="lg"
          saveButtonName="확인"
          closeButtonName="취소"
          useSaveButton={true}
          useSaveAfterClose={false}
          useCloseButton={false}
          onSave={() => {
            // 선택된 참석자들을 회의작성 팝업(modalToggle2)의 참석자그리드에 세팅
            const newAttendees = props.selectedWorkers.map((worker) => ({
              depNm: worker.depNm || worker.DEP_NM || '',
              id: worker.id || worker.ID || '',
              name: worker.name || worker.NAME || '',
              position: worker.position || worker.POSITION || '',
              rank: worker.rank || worker.RANK || '',
              tel: worker.tel || worker.TEL || '',
            }));

            // 중복 체크: 기존 참석자와 이름, 전화번호가 같은 경우 제외
            const filteredNewAttendees = newAttendees.filter((newAttendee) => {
              return !props.attendeeData.some((existingAttendee) => {
                return (
                  existingAttendee.name === newAttendee.name &&
                  existingAttendee.tel === newAttendee.tel
                );
              });
            });
            console.log([...props.attendeeData, ...filteredNewAttendees]);
            // 중복되지 않은 참석자만 추가
            props.setAttendeeData([
              ...props.attendeeData,
              ...filteredNewAttendees,
            ]);

            // 중복된 참석자가 있는 경우 알림
            if (filteredNewAttendees.length < newAttendees.length) {
              const duplicateCount =
                newAttendees.length - filteredNewAttendees.length;
              props.dispatch(
                props.showSnackbar({
                  message: `${duplicateCount}명의 중복된 참석자가 제외되었습니다.`,
                  type: 'warning',
                })
              );
            }

            props.setSelectedWorkers([]);
            props.setModalToggle3(false);
          }}
          content={
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                height: '100%',
                bgcolor: '#f6f7f8',
                p: 0,
                m: 0,
                mt: 0,
                pt: 0,
                overflow: 'hidden',
              }}
            >
              {/* Top Navigation Bar */}
              <Paper
                elevation={0}
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  borderBottom: '1px solid #f0f2f4',
                  bgcolor: 'white',
                  px: 3,
                  py: 1,
                  flexShrink: 0,
                  zIndex: 20,
                  m: 0,
                  mt: 0,
                  pt: 1,
                  pb: 1,
                }}
              >
                <Typography
                  variant="h6"
                  sx={{
                    fontWeight: 600,
                    color: '#111418',
                  }}
                >
                  참석인원 추가
                </Typography>
                <IconButton
                  onClick={() => props.setModalToggle3(false)}
                  sx={{
                    color: '#5f6368',
                    '&:hover': {
                      bgcolor: 'rgba(0, 0, 0, 0.04)',
                    },
                  }}
                >
                  <CloseIcon />
                </IconButton>
              </Paper>

              {/* Main Content */}
              <Box
                sx={{
                  display: 'flex',
                  flex: 1,
                  gap: 2,
                  p: 2,
                  overflow: 'hidden',
                }}
              >
                {/* 왼쪽: 검색 결과 리스트 */}
                <Paper
                  elevation={0}
                  sx={{
                    flex: 1,
                    p: 2,
                    minWidth: '300px',
                    bgcolor: 'white',
                    border: '1px solid #e0e0e0',
                    borderRadius: 2,
                    display: 'flex',
                    flexDirection: 'column',
                    overflow: 'hidden',
                  }}
                >
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: 2,
                      mb: 2,
                    }}
                  >
                    <TextField
                      placeholder="이름 또는 사번으로 검색"
                      variant="outlined"
                      size="small"
                      sx={{ flex: 1 }}
                      value={props.searchKeyword}
                      onChange={(e) => props.setSearchKeyword(e.target.value)}
                      onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                          props.handleSearchWorkers();
                        }
                      }}
                    />
                    <Button
                      variant="contained"
                      onClick={props.handleSearchWorkers}
                      sx={{
                        minWidth: '80px',
                        bgcolor: '#1976d2',
                        '&:hover': {
                          bgcolor: '#1565c0',
                        },
                      }}
                    >
                      검색
                    </Button>
                    <Button
                      variant="outlined"
                      onClick={() => {
                        // 전체 선택 (외부인 제외된 목록만)
                        const allWorkers = (props.modalRowData3 || []).filter(
                          (worker) => {
                            const yn =
                              worker?.internalYn ??
                              worker?.InternalYn ??
                              worker?.INTERNAL_YN ??
                              '0';
                            return yn !== 1 && yn !== '1' && yn !== true;
                          }
                        );
                        props.setSelectedWorkers([...allWorkers]);
                      }}
                      sx={{
                        minWidth: '80px',
                        borderColor: '#e0e0e0',
                        color: '#5f6368',
                        '&:hover': {
                          borderColor: '#1976d2',
                          bgcolor: 'rgba(25, 118, 210, 0.04)',
                        },
                      }}
                    >
                      전체선택
                    </Button>
                  </Box>
                  <div
                    className="ag-theme-alpine"
                    style={{ height: '550px', width: '100%' }}
                  >
                    <BusinessGridCommon
                      addYn1={'N'}
                      deleteYn1={'N'}
                      refreshYn1={'N'}
                      onCellClicked={(params) => {
                        // 행 클릭 시 참석자 선택/해제
                        const worker = params.data;
                        // ID 비교 (대소문자 모두 지원)
                        const workerId = worker.ID || worker.id || '';
                        const isSelected = props.selectedWorkers.some(
                          (selectedWorker) => {
                            const selectedId =
                              selectedWorker.ID || selectedWorker.id || '';
                            return (
                              selectedId && workerId && selectedId === workerId
                            );
                          }
                        );

                        if (isSelected) {
                          // 이미 선택된 경우 제거
                          props.setSelectedWorkers(
                            props.selectedWorkers.filter((selectedWorker) => {
                              const selectedId =
                                selectedWorker.ID || selectedWorker.id || '';
                              return !(
                                selectedId &&
                                workerId &&
                                selectedId === workerId
                              );
                            })
                          );
                        } else {
                          // 선택되지 않은 경우 추가
                          props.setSelectedWorkers([
                            ...props.selectedWorkers,
                            worker,
                          ]);
                        }
                      }}
                      columnDefs={[
                        {
                          field: 'name',
                          headerName: '성명',
                          maxWidth: 150,
                        },
                        {
                          field: 'position',
                          headerName: '직책',
                          maxWidth: 150,
                        },
                        {
                          field: 'rank',
                          headerName: '직위',
                          maxWidth: 150,
                        },
                        {
                          field: 'depNm',
                          headerName: '소속',
                          maxWidth: 150,
                        },
                        {
                          field: 'tel',
                          headerName: '전화번호',
                          maxWidth: 150,
                        },
                      ]}
                      rowData={props.modalRowData3?.filter((worker) => {
                        // 외부인 제외 (조회 결과 보강 필터)
                        const yn =
                          worker?.internalYn ??
                          worker?.InternalYn ??
                          worker?.INTERNAL_YN ??
                          '0';
                        if (yn === 1 || yn === '1' || yn === true) return false;

                        if (!props.searchKeyword.trim()) return true;
                        const keyword = props.searchKeyword.toLowerCase();
                        return (
                          worker.name?.toLowerCase().includes(keyword) ||
                          worker.position?.toLowerCase().includes(keyword) ||
                          worker.rank?.toLowerCase().includes(keyword) ||
                          worker.id?.toLowerCase().includes(keyword) ||
                          worker.depNm?.toLowerCase().includes(keyword)
                        );
                      })}
                      defaultColDef={{
                        minWidth: 80,
                        resizable: true,
                        sortable: true,
                      }}
                    />
                  </div>
                </Paper>
                <Paper
                  elevation={0}
                  sx={{
                    width: '400px',
                    p: 2,
                    bgcolor: 'white',
                    border: '1px solid #e0e0e0',
                    borderRadius: 2,
                    display: 'flex',
                    flexDirection: 'column',
                    overflow: 'hidden',
                  }}
                >
                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      mb: 2,
                      pb: 2,
                      borderBottom: '1px solid #f0f2f4',
                    }}
                  >
                    <Typography
                      variant="h6"
                      sx={{
                        fontWeight: 600,
                        color: '#111418',
                      }}
                    >
                      선택된 참석자 ({props.selectedWorkers.length}명)
                    </Typography>
                    <Button
                      variant="outlined"
                      size="small"
                      onClick={() => {
                        props.setSelectedWorkers([]);
                      }}
                      disabled={props.selectedWorkers.length === 0}
                      sx={{
                        borderColor: '#e0e0e0',
                        color: '#d32f2f',
                        '&:hover': {
                          borderColor: '#d32f2f',
                          bgcolor: 'rgba(211, 47, 47, 0.04)',
                        },
                        '&:disabled': {
                          borderColor: '#e0e0e0',
                          color: '#bdbdbd',
                        },
                      }}
                    >
                      전체삭제
                    </Button>
                  </Box>
                  <Box
                    sx={{
                      flex: 1,
                      overflow: 'auto',
                      bgcolor: '#ffffff',
                      borderRadius: 1,
                      p: 1,
                    }}
                  >
                    {props.selectedWorkers.map((worker, index) => (
                      <Paper
                        key={worker.id || index}
                        elevation={0}
                        sx={{
                          p: 1.5,
                          mb: 1,
                          bgcolor: '#f8f9fa',
                          border: '1px solid #e0e0e0',
                          borderRadius: 1.5,
                          position: 'relative',
                          display: 'flex',
                          alignItems: 'center',
                          '&:hover': {
                            bgcolor: '#f0f2f4',
                            borderColor: '#1976d2',
                          },
                        }}
                      >
                        <AccountCircleIcon
                          sx={{
                            fontSize: 40,
                            color: '#1976d2',
                            mr: 1.5,
                          }}
                        />
                        <Box sx={{ flex: 1 }}>
                          <Typography
                            variant="body2"
                            sx={{ fontWeight: 600, color: '#111418', mb: 0.5 }}
                          >
                            {worker.name}
                          </Typography>
                          <Typography
                            variant="caption"
                            sx={{ color: '#5f6368', display: 'block' }}
                          >
                            {worker.depNm}
                          </Typography>
                        </Box>
                        <IconButton
                          size="small"
                          onClick={() => {
                            props.setSelectedWorkers(
                              props.selectedWorkers.filter(
                                (_, i) => i !== index
                              )
                            );
                          }}
                          sx={{
                            color: '#d32f2f',
                            '&:hover': {
                              bgcolor: 'rgba(211, 47, 47, 0.08)',
                            },
                          }}
                        >
                          <CloseIcon fontSize="small" />
                        </IconButton>
                      </Paper>
                    ))}
                    {props.selectedWorkers.length === 0 && (
                      <Box
                        sx={{
                          display: 'flex',
                          flexDirection: 'column',
                          alignItems: 'center',
                          justifyContent: 'center',
                          height: '100%',
                          textAlign: 'center',
                          py: 4,
                        }}
                      >
                        <PersonAddIcon
                          sx={{
                            fontSize: 64,
                            color: '#bdbdbd',
                            mb: 2,
                          }}
                        />
                        <Typography
                          variant="body2"
                          sx={{ color: '#5f6368', mt: 1 }}
                        >
                          선택된 참석자가 없습니다
                        </Typography>
                      </Box>
                    )}
                  </Box>
                </Paper>
              </Box>
            </Box>
          }
        />
      )}

      {/* 수급업체 선택 팝업 */}
      {props.modalToggle7 && (
        <Dialog
          title={null}
          titleSx={{ display: 'none', p: 0, m: 0, height: 0, minHeight: 0 }}
          open={props.modalToggle7}
          onClose={() => {
            props.setModalToggle7(false);
            props.setSelectedModalRowData7([]);
          }}
          contentSx={{
            p: '0 !important',
            pt: '0 !important',
            pb: '0 !important',
            px: '0 !important',
            py: '0 !important',
            m: '0 !important',
            mt: '0 !important',
            overflow: 'hidden',
            '&.MuiDialogContent-root': {
              padding: '0 !important',
              paddingTop: '0 !important',
            },
          }}
          fullWidth
          maxWidth="sm"
          sx={{ '& .MuiDialog-paper': { width: '700px', maxWidth: '700px' } }}
          saveButtonName="선택"
          closeButtonName="취소"
          useSaveButton={true}
          useSaveAfterClose={false}
          useCloseButton={false}
          onSave={props.handleSubcontractorSelection}
          content={
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                height: '100%',
                bgcolor: '#f6f7f8',
                p: 0,
                m: 0,
                mt: 0,
                pt: 0,
                overflow: 'hidden',
              }}
            >
              {/* Top Navigation Bar */}
              <Paper
                elevation={0}
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  borderBottom: '1px solid #f0f2f4',
                  bgcolor: 'white',
                  px: 3,
                  py: 1,
                  flexShrink: 0,
                  zIndex: 20,
                  m: 0,
                  mt: 0,
                  pt: 1,
                  pb: 1,
                }}
              >
                <Typography
                  variant="h6"
                  sx={{
                    fontWeight: 600,
                    color: '#111418',
                  }}
                >
                  수급업체 선택
                </Typography>
                <IconButton
                  onClick={() => {
                    props.setModalToggle7(false);
                    props.setSelectedModalRowData7([]);
                  }}
                  sx={{
                    color: '#5f6368',
                    '&:hover': {
                      bgcolor: 'rgba(0, 0, 0, 0.04)',
                    },
                  }}
                >
                  <CloseIcon />
                </IconButton>
              </Paper>

              {/* Main Content */}
              <Box sx={{ flex: 1, p: 2, overflow: 'auto' }}>
                <Paper
                  elevation={0}
                  sx={{
                    p: 2,
                    mb: 2,
                    bgcolor: 'white',
                    border: '1px solid #e0e0e0',
                    borderRadius: 2,
                  }}
                >
                  <Typography
                    variant="body2"
                    sx={{
                      color: '#5f6368',
                      mb: 1,
                    }}
                  >
                    참석자를 추가할 수급업체를 선택하세요. (다중 선택 가능)
                  </Typography>

                  <div
                    className="ag-theme-alpine"
                    style={{ height: '500px', width: '100%' }}
                  >
                    <BusinessGridCommon
                      addYn1={'N'}
                      deleteYn1={'N'}
                      refreshYn1={'N'}
                      rowSelection={'multiple'}
                      columnDefs={[
                        {
                          field: 'checkbox',
                          headerName: '',
                          width: 50,
                          minWidth: 50,
                          maxWidth: 50,
                          cellRenderer: (params) => (
                            <input
                              type="checkbox"
                              checked={props.selectedModalRowData7.some(
                                (item) => item.custCd === params.data.custCd
                              )}
                              onChange={(e) => {
                                e.stopPropagation();
                                if (e.target.checked) {
                                  props.setSelectedModalRowData7([
                                    ...props.selectedModalRowData7,
                                    params.data,
                                  ]);
                                } else {
                                  props.setSelectedModalRowData7(
                                    props.selectedModalRowData7.filter(
                                      (item) =>
                                        item.custCd !== params.data.custCd
                                    )
                                  );
                                }
                              }}
                            />
                          ),
                        },
                        {
                          field: 'custCd',
                          headerName: '업체코드',
                          width: 120,
                          hide: true,
                          cellStyle: {
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                          },
                        },
                        {
                          field: 'custNm',
                          headerName: '업체명',
                          flex: 1,
                          width: 250,
                          cellStyle: {
                            display: 'flex',
                            justifyContent: 'flex-start',
                            alignItems: 'center',
                          },
                        },
                        {
                          field: 'ceo',
                          headerName: '대표자명',
                          width: 110,
                          cellStyle: {
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                          },
                        },
                        {
                          field: 'ceoTel',
                          headerName: '대표자연락처',
                          width: 150,
                          cellStyle: {
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                          },
                        },
                      ]}
                      rowData={props.modalRowData7}
                      onCellClicked={(params) => {
                        // 행 클릭 시 체크박스 토글
                        const isSelected = props.selectedModalRowData7.some(
                          (item) => item.custCd === params.data.custCd
                        );

                        if (isSelected) {
                          props.setSelectedModalRowData7(
                            props.selectedModalRowData7.filter(
                              (item) => item.custCd !== params.data.custCd
                            )
                          );
                        } else {
                          props.setSelectedModalRowData7([
                            ...props.selectedModalRowData7,
                            params.data,
                          ]);
                        }
                      }}
                    />
                  </div>
                </Paper>

                {/* 선택된 수급업체 표시 */}
                <Paper
                  elevation={0}
                  sx={{
                    p: 2,
                    bgcolor: 'white',
                    border: '1px solid #e0e0e0',
                    borderRadius: 2,
                  }}
                >
                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      mb: 2,
                      pb: 2,
                      borderBottom: '1px solid #f0f2f4',
                    }}
                  >
                    <Typography
                      variant="h6"
                      sx={{
                        fontWeight: 600,
                        color: '#111418',
                      }}
                    >
                      선택된 수급업체 ({props.selectedModalRowData7.length}개)
                    </Typography>
                  </Box>
                  {props.selectedModalRowData7.length > 0 ? (
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                      {props.selectedModalRowData7.map((item, index) => (
                        <Chip
                          key={item.custCd}
                          label={item.custNm}
                          size="small"
                          sx={{
                            backgroundColor: '#e3f2fd',
                            color: '#1976d2',
                            border: '1px solid #90caf9',
                            '&:hover': {
                              backgroundColor: '#bbdefb',
                            },
                            '& .MuiChip-deleteIcon': {
                              color: '#1976d2',
                              '&:hover': {
                                color: '#0d47a1',
                              },
                            },
                          }}
                          onDelete={() => {
                            props.setSelectedModalRowData7(
                              props.selectedModalRowData7.filter(
                                (selected) => selected.custCd !== item.custCd
                              )
                            );
                          }}
                        />
                      ))}
                    </Box>
                  ) : (
                    <Box
                      sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        py: 4,
                        textAlign: 'center',
                      }}
                    >
                      <Typography variant="body2" sx={{ color: '#5f6368' }}>
                        선택된 수급업체가 없습니다
                      </Typography>
                    </Box>
                  )}
                </Paper>
              </Box>
            </Box>
          }
        />
      )}
    </React.Fragment>
  );
}

export default SUB_BASIC_03;
